module.exports = __webpack_public_path__ + "img/sompo.7b462b77.svg";